import * as React from 'react';

const SvgStatusPlayingFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M5 20.37 19.5 12 5 3.63v16.74Z" })
);

export { SvgStatusPlayingFill as default };
//# sourceMappingURL=StatusPlayingFill.es.js.map
